module.exports = __webpack_public_path__ + "static/puzzle-9c05ada61e9d88a19e65a7ba291e5748.svg";